import React from "react";
import { withRouter } from "react-router-dom";
import UsuarioService from "../app/service/usuarioService";
import { mensagemErro } from "../components/toastr";
import { AuthContext } from "../main/provedorAutenticacao";

class Login extends React.Component {
  state = {
    username: "",
    senha: "",
    mostrarSenha: false,
  };

  constructor() {
    super();
    this.service = new UsuarioService();
  }

  validar() {
    const msgs = [];
    if (!this.state.username) {
      msgs.push("O campo usuário é obrigatório.");
    }
    if (!this.state.senha) {
      msgs.push("O campo senha é obrigatório.");
    }
    return msgs;
  }

  entrar = () => {
    const msgs = this.validar();

    if (msgs && msgs.length > 0) {
      msgs.forEach((msg) => mensagemErro(msg));
      return false;
    }

    this.service
      .autenticar({
        username: this.state.username,
        password: this.state.senha,
      })
      .then((response) => {
        // Agora o backend retorna: { ou, name, message, token, status }
        const usuarioAutenticado = {
          username: response.data.name,
          ou: response.data.ou,
          token: response.data.token,
        };

        this.context.iniciarSessao(usuarioAutenticado);
        this.props.history.push("/home");
      })
      .catch((erro) => {
        if (erro.response && erro.response.status === 0) {
          mensagemErro("Servidor indisponível");
        } else {
          mensagemErro(erro.response?.data || "Erro ao autenticar");
        }
      });
  };

  toggleSenha = () => {
    this.setState({ mostrarSenha: !this.state.mostrarSenha });
  };

  render() {
    return (
      <div className="bg-transparent text-white min-h-screen flex items-center justify-center relative overflow-hidden ">
        {/* Fundo para mobile */}
        <div className="absolute inset-0 z-0 md:hidden mt-[140px] ">
          <img
            src="logo_esquerda.png"
            onError={(e) => (e.target.src = "https://placehold.co/80x80")}
            alt="Fundo"
            className="object-cover bg-gray-900 bg-opacity-80"
          />
        </div>

        {/* Container */}
        <div className="flex w-full max-w-4xl md:h-auto h-screen md:rounded-lg overflow-hidden shadow-lg z-10 mt-[-150px]">
          {/* Imagem lateral (desktop) */}
          <div className="w-1/2 hidden md:block">
            <img
              src="logo_esquerda.png"
              onError={(e) => (e.target.src = "https://placehold.co/80x80")}
              alt="Imagem login"
              className="w-full h-full object-cover bg-gray-900 bg-opacity-80"
            />
          </div>

          {/* Formulário */}
          <div className="w-full md:w-1/2 flex flex-col justify-center px-8 py-10 bg-gray-900 bg-opacity-80 md:bg-opacity-100">
            {/* Logo e título */}
            <div className="text-center mb-6">
              <img
                src="jucesc.png"
                onError={(e) => (e.target.src = "https://placehold.co/40x40")}
                className="mx-auto mb-0"
                alt="Logo"
                width="90"
              />
              <h1 className="text-2xl font-[Montserrat, Sans-serif] font-bold mb-1">
                JUCESC
              </h1>
              <p className="text-sm text-gray-300 font-light">
                Junta Comercial do Estado de SC
              </p>
            </div>

            {/* Inputs */}
            <div className="space-y-4">
              {/* Username */}
              <div className="flex border rounded-xl relative">
                <input
                  type="text"
                  value={this.state.username}
                  onChange={(e) => this.setState({ username: e.target.value })}
                  className="w-full py-3 px-4 rounded-xl bg-slate-700 focus:outline-none border-none text-gray-200"
                  placeholder="Usuário"
                />
                <span className="icon flex items-center px-2">
                  <i className="fas fa-user text-white text-lg"></i>
                </span>
              </div>

              {/* Senha */}
              <div className="flex border rounded-xl relative">
                <input
                  type={this.state.mostrarSenha ? "text" : "password"}
                  value={this.state.senha}
                  onChange={(e) => this.setState({ senha: e.target.value })}
                  className="w-full py-3 px-4 rounded-xl bg-slate-700 focus:outline-none border-none text-gray-200"
                  placeholder="Senha"
                />
                <span
                  className="icon flex items-center px-2 cursor-pointer"
                  onClick={this.toggleSenha}
                >
                  <i
                    className={`${
                      this.state.mostrarSenha ? "fas fa-eye-slash" : "fas fa-eye"
                    } text-white text-lg`}
                  ></i>
                </span>
              </div>

              {/* Botão entrar */}
              <button
                onClick={this.entrar}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-lg text-sm font-semibold"
              >
                Entrar
              </button>
            </div>

            {/* Links extras */}
            <div className="mt-4 text-center text-sm">
              <a href="#/login" className="text-gray-300 hover:text-white">
                esqueceu a senha?
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Login.contextType = AuthContext;
export default withRouter(Login);
